module.exports = __webpack_public_path__ + "static/media/cafe24_url.dce99fae.png";